import React, { useEffect, useState } from "react";
import "./style.scss";
import Table from "../../Table";
import { getPayoutList } from "../../../utils/apis/payments";
import { useSelector } from "react-redux";
import moment from "moment";
import { formatDateInTimeZone } from "../../../utils/helpers/string";

function PayoutTable() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [payoutList, setPayoutList] = useState([]);
  const { idToken } = useSelector((state) => state.auth);
  const [isLoading, setisLoading] = useState();
  const [params, setParams] = useState({
    page: 1,
    page_size: 20,
  });
  const fetchPayout = async () => {
    try {
      setisLoading(true);
      const response = await getPayoutList(idToken, params);
      // Handle response or set state based on the response
      setPayoutList(response);
    } catch (error) {
      // Handle errors here
      console.error("Error fetching payout list:", error);
      // You can also set an error state or display an error message to the user
    } finally {
      setisLoading(false);
    }
  };
  useEffect(() => {
    fetchPayout();
  }, [JSON.stringify(params)]);

  const columns = [
    { Header: "Payout Type", accessor: "payout_type" },
    { Header: "Method", accessor: "method" },
    { Header: "Amount", accessor: "amount" },
    {
      Header: "Profit Split",
      accessor: "profit_split",
      Cell: ({ value }) => (
        <div className="profit-share">
          <span className="text">{value}</span>
        </div>
      ),
    },
    { Header: "Login id", accessor: "login_id" },
    {
      Header: "Created At",
      accessor: "created_at",
      Cell: ({ value }) => (
        <div className="profit-share">
          <span className="text">{formatDateInTimeZone(value)}</span>
        </div>
      ),
    },
    {
      Header: "Status",
      accessor: "status",
      Cell: ({ value }) => (
        <div className="btn-wrapper">
          <button
            className={`status-btn ${
              value === "approved"
                ? "status-approved"
                : value === "new" || value === "Request Payout"
                ? "status-request"
                : value === "error"
                ? "status-error"
                : ""
            }`}
          >
            {value}
          </button>
          {value === "error" && (
            <button className="reload-btn btn">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="17"
                height="17"
                viewBox="0 0 17 17"
                fill="none"
              >
                <path
                  d="M14.7952 6.87537C14.7264 6.60794 14.4538 6.44695 14.1863 6.51578C13.9189 6.58461 13.7579 6.8572 13.8268 7.12463L14.7952 6.87537ZM14 8.5C14 11.5376 11.5376 14 8.5 14V15C12.0899 15 15 12.0899 15 8.5H14ZM8.5 14C5.46243 14 3 11.5376 3 8.5H2C2 12.0899 4.91015 15 8.5 15V14ZM3 8.5C3 5.46243 5.46243 3 8.5 3V2C4.91015 2 2 4.91015 2 8.5H3ZM8.5 3C10.1289 3 11.5918 3.70745 12.5996 4.83346L13.3448 4.16654C12.1553 2.83755 10.4251 2 8.5 2V3ZM13.8268 7.12463C13.9398 7.56369 14 8.02444 14 8.5H15C15 7.93966 14.929 7.39517 14.7952 6.87537L13.8268 7.12463Z"
                  fill="white"
                />
                <path
                  d="M13.0356 1.5V5.03553H9.50011"
                  stroke="white"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
          )}
          <div className="tooltip">Re-request Payout</div>
        </div>
      ),
    },
  ];

  return (
    <div className="payout-table">
      <Table
        columns={columns}
        data={payoutList}
        params={params}
        setParams={setParams}
        isLoading={isLoading}
      />
    </div>
  );
}

export default PayoutTable;
